module.exports = __webpack_public_path__ + "static/img/notification_empty.601363c1.png";